/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_UpdatedInputs */

const en_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Updated!`)
};

const es_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Contraseña actualizada!`)
};

const fr_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe mis à jour !`)
};

const de_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort aktualisiert!`)
};

const ja_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードが更新されました！`)
};

const zh_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码已更新！`)
};

const ar_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحديث كلمة المرور!`)
};

const id_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata Sandi Diperbarui!`)
};

const it_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Aggiornata!`)
};

const ru_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль обновлен!`)
};

const pt_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha Atualizada!`)
};

const ko_password_updated = /** @type {(inputs: Password_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호가 업데이트되었습니다!`)
};

/**
* | output |
* | --- |
* | "Password Updated!" |
*
* @param {Password_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const password_updated = /** @type {((inputs?: Password_UpdatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_UpdatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_password_updated(inputs)
	if (locale === "es") return es_password_updated(inputs)
	if (locale === "fr") return fr_password_updated(inputs)
	if (locale === "de") return de_password_updated(inputs)
	if (locale === "ja") return ja_password_updated(inputs)
	if (locale === "zh") return zh_password_updated(inputs)
	if (locale === "ar") return ar_password_updated(inputs)
	if (locale === "id") return id_password_updated(inputs)
	if (locale === "it") return it_password_updated(inputs)
	if (locale === "ru") return ru_password_updated(inputs)
	if (locale === "pt") return pt_password_updated(inputs)
	return ko_password_updated(inputs)
});